import { isIE, supportsResizeAndIntersectionObserver } from "@1js/acui-common";

import { ExperimentChecker } from "./ExperimentChecker";

export const ribbonExperiments = {
  renderInitiallyEnabledRibbonIsEnabled:
    "RenderInitiallyEnabledRibbonIsEnabled",
  updatedTellMePlaceholderIsEnabled: "UpdatedTellMePlaceholderIsEnabled",
  multilineRibbonIsEnabled: "ReactMultilineRibbonIsEnabled",
  shadowRenderingIsEnabled: "ShadowRenderingIsEnabled",
  taskPaneResizingIsEnabled: "TaskPaneResizingIsEnabled",
  areMenusConnectedToStore: "AreMenusConnectedToStore",
  activateComboAndSpinControlOnEnter:
    "ActivateComboAndSpinMenuItemOnEnterIsEnabled",
  batchScaleDataInRibbon: "BatchScaleDataInRibbon",
  sharedShyRibbonIsEnabled: "SharedShyRibbonIsEnabled",
  ribbonCachedScalingIsEnabled: "ReactRibbonCachedScalingIsEnabled",
  quickRibbonScalingIsEnabled: "QuickRibbonScalingIsEnabled",
  delayRibbonAnimationComponents: "DelayAnimationComponentsIsEnabled",
  ribbonRenderBootThrottlingIsEnabled: "RibbonRenderBootThrottlingIsEnabled",
  delayTabHeaderCalculationsIsEnabled: "DelayTabHeaderCalculationsIsEnabled",
  ribbonUseV8Button: "Microsoft.Office.SharedOnline.FluentV8ButtonIsEnabled",
  ribbonUseV8MenuButton:
    "Microsoft.Office.SharedOnline.FluentV8MenuButtonIsEnabled",
  reactSharedHeaderIsEnabled: "ReactSharedHeaderIsEnabled",
  hideHeaderEmbedded: "HideHeaderEmbedded",
  delayRenderTooltipsIsEnabled: "DelayRenderTooltipsIsEnabled",
  disableRibbonAnimationComponents: "DisableAnimationComponentsIsEnabled",
  delayInstallAddInIsEnabled: "DelayInstallAddInIsEnabled",
  modernUxExperimentOneIsEnabled:
    "Microsoft.Office.WordOnline.ModernUxExperimentOne",
  buildTimeRibbonScalingIsEnabled: "BuildTimeRibbonScalingIsEnabled",
  tooltipsTargetOverflowSetItemEnabled: "TooltipsTargetOverflowSetItemEnabled",
  disableColorPickerFancyTooltips: "DisableColorPickerFancyTooltips",
  batchTopBarScaleDataInRibbon: "BatchTopBarScaleDataInRibbon",
  suppressCalloutWithOccludedTargetIsEnabled:
    "SuppressCalloutWithOccludedTargetIsEnabled",
  buildTimeRibbonScalingMLRIsEnabled:
    "Microsoft.Office.SharedOnline.BuildTimeRibbonScalingMLRIsEnabled",
  decentralizedScalingLogicIsEnabled:
    "Microsoft.Office.SharedOnline.DecentralizedScalingLogicIsEnabled",
  perfMarkersIsEnabled: "Microsoft.Office.SharedOnline.PerfMarkersIsEnabled",
  perfMarkerThrottlingOverrideIsEnabled:
    "Microsoft.Office.SharedOnline.PerfMarkerThrottlingOverrideIsEnabled",
  shadowRenderingIsEnabledFG:
    "Microsoft.Office.SharedOnline.ShadowRenderingIsEnabled",
  areMenusConnectedToStoreFG:
    "Microsoft.Office.SharedOnline.AreMenusConnectedToStore",
  buildTimeRibbonScalingCombined:
    "Microsoft.Office.SharedOnline.BuildTimeRibbonScalingCombinedIsEnabled",
  shouldContextualTabUseNormalTabStyles:
    "ShouldContextualTabUseNormalTabStyles",
  zoomSliderIsEnabled: "ZoomSliderIsEnabled",
  shouldAlignPreviewGalleryVertically: "ShouldAlignPreviewGalleryVertically",
  shouldMergeAppToggleButtonMenuItemStyles:
    "ShouldMergeAppToggleButtonMenuItemStyles",
  responsiveRibbonScalingSLRIsEnabled:
    "Microsoft.Office.SharedOnline.ResponsiveRibbonScalingSLRIsEnabled",
  // Task 5728502: Clean change gate of Taskpane scrollable functionality
  setTaskPaneVerticalScrollAuto:
    "SharedOnline.ChangeGate.SetTaskPaneVerticalScrollAuto",
  multiWindowSupportIsEnabled:
    "SharedOnline.ChangeGate.MultiWindowSupportIsEnabled",
  shouldMergeStylesIntoMenuItems:
    "SharedOnline.ChangeGate.ShouldMergeStylesIntoMenuItems",
  multiTaskPaneOpenFixIsEnabled:
    "SharedOnline.ChangeGate.MultiTaskPaneOpenFixIsEnabled",
};

export const checkExperiment = (
  context: ExperimentChecker,
  feature: string
) => {
  return (
    context.isExperimentalFeatureEnabled &&
    context.isExperimentalFeatureEnabled(feature)
  );
};

export const isShyRibbonEnabled = (context: ExperimentChecker) => {
  return isShyRibbonFeatureEnabled(context.isExperimentalFeatureEnabled);
};

export const isShyRibbonFeatureEnabled = (
  isFeatureEnabled?: (
    feature: string,
    defaultValue?: boolean | undefined
  ) => boolean
) => {
  return (
    isFeatureEnabled !== undefined &&
    isFeatureEnabled(ribbonExperiments.sharedShyRibbonIsEnabled) &&
    isFeatureEnabled(ribbonExperiments.reactSharedHeaderIsEnabled) &&
    !isFeatureEnabled(ribbonExperiments.hideHeaderEmbedded) &&
    !isIE()
  );
};

export const isResponsiveRibbonScalingSLREnabled = (
  context: ExperimentChecker
) => {
  return isResponsiveRibbonScalingSLRFeatureEnabled(
    context.isExperimentalFeatureEnabled
  );
};

export const isResponsiveRibbonScalingSLRFeatureEnabled = (
  isFeatureEnabled?: (
    feature: string,
    defaultValue?: boolean | undefined
  ) => boolean
) => {
  return (
    isFeatureEnabled !== undefined &&
    isFeatureEnabled(ribbonExperiments.responsiveRibbonScalingSLRIsEnabled) &&
    !isIE() &&
    supportsResizeAndIntersectionObserver()
  );
};
